import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = {
  ...defaultValues,
  'contact.phone.number': '+44 16 1768 1880',
  'page.policies_specific_country.url': {
    en: '/p/england-policies-and-regulations',
    fr: '/p/politiques-et-reglementations-angleterre',
  },
};

export default config;
